// Documento: Solicitudes externas o API requests
// Categoría: General
// Última actualización: 2024-12-28

const document = {
  "id": "solicitudes-externas-practico",
  "title": "Solicitudes externas o API requests",
  "category": "General",
  "description": "Guía práctica para integrar tu bot con sistemas externos mediante API requests. Aprende a configurar solicitudes GET, POST y otros métodos para obtener información dinámica.",
  "explanations": [
    {
      "title": "Qué son las solicitudes externas",
      "content": "Las solicitudes externas o API requests permiten que su integrar a su bot con sistemas externos que permitan este tipo de conexiones. Esta información puede ser obtenida dinámicamente y ser guardada en un campo personalizado para su uso."
    },
    {
      "title": "Tipos de petición disponibles",
      "content": "La herramienta permite hacer los siguientes tipos de petición: GET, POST, DELETE, PUT y PATCH. Nota: El cuerpo de la solicitud solo se mostrará para los métodos que permitan usar cuerpo, por ejemplo POST."
    },
    {
      "title": "Pro tips",
      "content": "• Utilizar la solicitud externa en un flujo que es llamado por un disparador de AI.\n\n• Utilizar la solicitud externa en un flujo activado por administradores para cargar la información en un campo del bot.\n\n• Utilizar la solicitud externa en el mensaje de bienvenida de cada chat, asegurándose que el cliente siempre tendrá la última información disponible. Este mensaje de bienvenida puede ser configurado para dispararse cada 24 horas."
    }
  ],
  "steps": [
    {
      "title": "Acceder a la herramienta de solicitudes externas",
      "content": "Para acceder a esta herramienta acceda a Flujos > Editar o crear un flujo > Añadir contenido > Acciones > Solicitudes de API externa. Al hacer esto se mostrará la herramienta de solicitudes externas con todos los componentes que puede utilizar."
    },
    {
      "title": "Configurar la solicitud",
      "content": "Para utilizar la herramienta simplemente introduzca una URL y complete los parámetros necesarios, por ejemplo un header de autenticación."
    },
    {
      "title": "Probar la solicitud",
      "content": "Puede verificar que la solicitud está funcionando probándola. Al apretar el botón \"Probar Ahora\" elija Web Chat."
    },
    {
      "title": "Guardar la información en campo personalizado",
      "content": "Una vez que su solicitud está funcionando como esperaba puede guardar la información contenida en la respuesta en un campo personalizado. Si desea extraer información específica lo puede hacer desde los parámetros de la URL o utilizando JSONPath."
    },
    {
      "title": "Utilizar la información guardada",
      "content": "Una vez que la información esté guardada en un campo personalizado la puede utilizar como base de datos de sus bots."
    }
  ],
  "tags": [
    "api",
    "solicitudes",
    "externas",
    "integraciones",
    "json",
    "campos-personalizados",
    "flujos"
  ],
  "lastUpdated": "2024-12-28",
  "difficulty": "básico"
};

export default document;
